export const en = {
    code: "en",
    country: "GB",
    translations: {
        news: "News",
        events: "Events",
        more: "more",
        all: "All",
        result: "Result",
        results: "Results",
        results_filter_txt: "to the filter selection",
        filter_topic_title: "Topic",
        filter_topic_choose: "Choose topic",
        filter_topic_button: "Execute",
        filter_topic_dropdown_placeholder: "Filter area for topic selection",
        filter_time_title: "Period",
        filter_time_choose: "Choose period",
        filter_time_button: "Execute",
        filter_time_dropdown_placeholder: "Filter area for period selection",
        filter_time_errordate: "Please check if a correct date has been entered and if the start date is before the end date.",
        filter_active_zone_title: "Your filter selection",
        filter_active_zone_delete: "Reset Filter",
        timeItems_buttons_7_title: "Next 7 days",
        timeItems_buttons_30_title: "Next 30 days",
        timeItems_inputs_start_label: "Start",
        timeItems_inputs_start_placeholder: "Date",
        timeItems_inputs_end_label: "Stop",
        timeItems_inputs_end_placeholder: "Date",
    }
};
